import { getDebugLogger } from '@ori/checkout-utils';
import { Logger } from '@ori/logger';
import { APP_NAME, PACKAGE_NAME, TEAM_NAME } from './constants';
export const mainLogger = new Logger(PACKAGE_NAME, {
  teamName: TEAM_NAME
});
export const logDebug = getDebugLogger(APP_NAME);